import React from 'react'

import {
    CentralToolbarSection,
    RightToolbarSection
} from '../navigation-ui/nav-header'



import MuiAppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

import { ReactFC } from '../types'

import { CircleBottomNavigation } from './CircleBottomNavigation'

import { ParentCircleIcon } from './ParentCircleIcon'
import { PageSectionWithAppMenu } from 'navigation/MainPageContainer'
import ToggleMenuButton from 'navigation/ToggleMenuButton'
import { CreatePageMenuItem } from 'navigation/navigation-items'
import styled, { createGlobalStyle, css } from 'styled-components'
import { AppBarTitle } from 'navigation-ui/hideSmallScreen'
import { Logo } from 'navigation/Logo'
import { useBodyScroll } from 'navigation-ui/useBodyScroll'

export const ScrolledArea = styled.div<{ bottomBar?: boolean }>`
width: 100%;
height: 100%;
`
const CssOverrides = createGlobalStyle`
  #body {
    overflow-y: scroll;
  }
`

export const ScreenContainer = styled.div<any>`
margin-top: 64px;
width: 100%;
${({ bottomBar, theme }) => bottomBar && css`
    ${theme.breakpoints.down('xs')} {
        margin-bottom: ${theme.bottomNavSize}px;
    }
  `
    }
`

export const CircleDesktop: ReactFC<{ right, title }> = (props) => {
    const { right, children, title } = props
    useBodyScroll()
    return (
        <ScreenContainer bottomBar>
            <CssOverrides />
            <MuiAppBar position="fixed" data-testid="nav-header">
                <Toolbar>
                    <ToggleMenuButton />
                    <Logo />
                    <ParentCircleIcon />
                    <CentralToolbarSection>
                        <AppBarTitle>
                            {title}
                        </AppBarTitle>
                    </CentralToolbarSection>
                    <RightToolbarSection>
                        {right}
                    </RightToolbarSection>
                </Toolbar>
            </MuiAppBar>
            <ScrolledArea>
                <PageSectionWithAppMenu create={<CreatePageMenuItem />}>
                    {children}
                </PageSectionWithAppMenu>
            </ScrolledArea>
            <CircleBottomNavigation fixed />
        </ScreenContainer>
    )
}


export default CircleDesktop
